import {UPDATE_DATA, ADD_DOCUMENT, RESET_DATA, RESET_DOCUMENT, GET_CUSTOMIZATION} from "../types";

const INITIAL_STATE = {
    cedula:'',
    mail:'',
    telefono:'',
    documents:[],
    uploadFilesInfo:{docs:1,faces:2},
    workflowList:{filesInfo:[],total:0},
    workflowDetails:{pendingSigners:[],finishedSigners:[]},
    customization:{}
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_CUSTOMIZATION:
        case UPDATE_DATA:
            return {...state, ...action.payload};
        case ADD_DOCUMENT:
            return {...state,documents:[...state.documents,action.payload]};
        case RESET_DATA:
            return INITIAL_STATE;
        case RESET_DOCUMENT:
            return {...state,documents:[]};
        default:
            return state;
    }
};
export default reducer;